<template>
  <div class="preWarning">
    <el-tabs v-model="activateTab" @tab-click="handleTabClick">
      <!--      <el-tab-pane key="approvalMatters" name="approvalMatters" lazy>-->
      <!--        <span slot="label"><span>{{ $t('CargoMsg.Cargo_ApprovalMatters') }}</span><span v-if="approvalMatter.count > 0">(</span><span style="color: #f56c6c">{{ approvalMatter.count }}</span><span>)</span></span>-->
      <!--        <tab-approval-matters ref="approvalMatters" key="approvalMatters" type="approvalMatters" :approval-matter="approvalMatter" />-->
      <!--      </el-tab-pane>-->
      <el-tab-pane v-if="showTab('SE')" key="se" name="se" :lazy="curLob !== 'SE'">
        <span slot="label"><span class="tabSpanStyle">{{ $t('CargoMsg.Cargo_OceanExport') }}</span><span>(</span><span style="color: #f56c6c">{{ lobCounts.se }}</span><span>)</span></span>
        <tab-warning ref="se" key="se" type="se" lob="SE" :keep-state="keepState" @resetCount="resetLobCount" />
      </el-tab-pane>
      <el-tab-pane v-if="showTab('SI')" key="si" name="si" :lazy="curLob !== 'SI'">
        <span slot="label"><span class="tabSpanStyle">{{ $t('CargoMsg.Cargo_OceanImport') }}</span><span>(</span><span style="color: #f56c6c">{{ lobCounts.si }}</span><span>)</span></span>
        <tab-warning ref="si" key="si" type="si" lob="SI" :keep-state="keepState" @resetCount="resetLobCount" />
      </el-tab-pane>
      <el-tab-pane v-if="showTab('AE')" key="ae" name="ae" :lazy="curLob !== 'AE'">
        <span slot="label"><span class="tabSpanStyle">{{ $t('CargoMsg.Cargo_AirExport') }}</span><span>(</span><span style="color: #f56c6c">{{ lobCounts.ae }}</span><span>)</span></span>
        <tab-warning ref="ae" key="ae" type="ae" lob="AE" :keep-state="keepState" @resetCount="resetLobCount" />
      </el-tab-pane>
      <el-tab-pane v-if="showTab('AI')" key="ai" name="ai" :lazy="curLob !== 'AI'">
        <span slot="label"><span class="tabSpanStyle">{{ $t('CargoMsg.Cargo_AirImport') }}</span><span>(</span><span style="color: #f56c6c">{{ lobCounts.ai }}</span><span>)</span></span>
        <tab-warning ref="ai" key="ai" type="ai" lob="AI" :keep-state="keepState" @resetCount="resetLobCount" />
      </el-tab-pane>
      <el-tab-pane v-if="showTab('RE')" key="re" name="re" :lazy="curLob !== 'RE'">
        <span slot="label"><span class="tabSpanStyle">{{ $t('CargoMsg.Cargo_RailwayExport') }}</span><span>(</span><span style="color: #f56c6c">{{ lobCounts.re }}</span><span>)</span></span>
        <tab-warning ref="re" key="re" type="re" lob="RE" :keep-state="keepState" @resetCount="resetLobCount" />
      </el-tab-pane>
      <el-tab-pane v-if="showTab('RI')" key="ri" name="ri" :lazy="curLob !== 'RI'">
        <span slot="label"><span class="tabSpanStyle">{{ $t('CargoMsg.Cargo_RailwayImport') }}</span><span>(</span><span style="color: #f56c6c">{{ lobCounts.ri }}</span><span>)</span></span>
        <tab-warning ref="ri" key="ri" type="ri" lob="RI" :keep-state="keepState" @resetCount="resetLobCount" />
      </el-tab-pane>
      <el-tab-pane v-if="showTab('IE')" key="ie" name="ie" :lazy="curLob !== 'IE'">
        <span slot="label"><span class="tabSpanStyle">{{ $t('CargoMsg.Cargo_IntegratedJob') }}</span><span>(</span><span style="color: #f56c6c">{{ lobCounts.ie }}</span><span>)</span></span>
        <tab-warning ref="ie" key="ie" type="ie" lob="IE" :keep-state="keepState" @resetCount="resetLobCount" />
      </el-tab-pane>
      <!-- <el-tab-pane key="ri" name="ri" lazy>
        <span slot="label"><span>{{ $t('CargoMsg.Cargo_RailwayImport') }}</span><span>(</span><span style="color: #f56c6c">{{ lobCounts.ri }}</span><span>)</span></span>
        <tab-warning ref="ri" key="ri" type="re" lob="RI" @resetCount="resetLobCount" />
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import PreWarningList from './components/PreWarningList'
import { getSopWaringList, getSopWaringIgnoreList, sopWaringOperate, queryWarningInfoLobCount } from '@/api/sop'
import TabWarning from '@/views/dashboard/admin/components/PreWarning/components/tabWarning'
import { cache, cacheName } from '@/utils/cacheManager'
import TabApprovalMatters from '@/views/dashboard/admin/components/PreWarning/components/tabApprovalMatters'
import dateUtils from '@/utils/dateUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'PreWarning',
  components: { TabWarning, PreWarningList, TabApprovalMatters },
  props: {
    preWarningLob: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFirst: true,
      keepState: {},
      showJobTypes: [],
      activateTab: null,
      lobCounts: {
        se: '0',
        si: '0',
        ae: '0',
        ai: '0',
        re: '0',
        ri: '0',
        ie: '0'
      },
      preFilterDialogVisible: false,
      ignoreFilterDialogVisible: false,
      preApi: {
        list: getSopWaringList,
        operate: sopWaringOperate
      },
      ignoreApi: {
        list: getSopWaringIgnoreList,
        operate: sopWaringOperate
      },
      approvalMatter: {
        count: 0
      },
      disabledAutoRefresh: false, // 是否禁用自动刷新
      keepSelectedNode: false, // 是否保持选中节点
      keepQueryCondition: false // 是否保持查询条件
    }
  },
  computed: {
    curLob() {
      return (this.keepState && this.keepState.lob) || 'SE'
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    },
    // preWarningLob(newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     this.activateTab = newVal
    //   }
    // }
    preWarningLob: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.activateTab = newVal.toLowerCase()
        }
      }
    }
  },
  mounted() {
    // 优先取 保存配置项 里的lob
  },
  created() {
    // this.init()
    this.activated()
  },
  activated() {
    this.activated()
  },
  methods: {
    activated() {
      this.disabledAutoRefresh = false
      this.keepSelectedNode = false
      this.keepQueryCondition = false
      const preWarningSetting = LocalStorageUtilsNew.getConfiguration('preWarning-setting')
      if (preWarningSetting) {
        this.disabledAutoRefresh = preWarningSetting.disabledAutoRefresh
        this.keepSelectedNode = preWarningSetting.keepSelectedNode
        this.keepQueryCondition = preWarningSetting.keepQueryCondition
      }
      if (this.isFirst) {
        this.init()
        this.isFirst = false
      } else {
        if (this.keepSelectedNode || this.keepQueryCondition) {
          this.keepState = JSON.parse(sessionStorage.getItem('keepState'))
        }
        if (!this.keepQueryCondition) {
          this.$refs[this.activateTab].resetFilter()
        }
        if (!this.disabledAutoRefresh) {
          this.$refs[this.activateTab].handleFilter()
        }
      }
    },
    refreshBySetting() {
      if (!this.disabledAutoRefresh) {
        this.refreshPage()
      }
    },
    async init() {
      this.keepState = JSON.parse(sessionStorage.getItem('keepState'))
      await cache.load(cacheName.CONFIG)
      const dashboardShowJobType = cache.config.get('dashboardShowJobType')
      this.showJobTypes = !dashboardShowJobType || dashboardShowJobType.trim() === '' ? [] : dashboardShowJobType.split(',')
      if (this.keepState && this.keepState.lob) {
        if (!this.activateTab || this.activateTab === '0') {
          this.activateTab = this.keepState.lob.toLowerCase()
        }
      } else {
        if (!this.showJobTypes || this.showJobTypes.length === 0) { // 等于0，展示所有业务
          if (!this.activateTab || this.activateTab === '0') {
            this.activateTab = 'se'
          }
        } else {
          if (!this.activateTab || this.activateTab === '0') {
            this.activateTab = this.showJobTypes[0].toLowerCase()
          } else {
            if (this.showJobTypes.findIndex(item => item.toLowerCase() === this.activateTab) <= -1) {
              this.activateTab = this.showJobTypes[0].toLowerCase()
            }
          }
        }
        // 如果默认展示的是"审批事项"页签,那么要加载一下各大业务的预警数量
        const params = {
          'startTime': dateUtils.formatStandardDate(new Date()),
          'endTime': dateUtils.formatStandardDate(new Date()),
          'branchId': this.$store.getters.currentOfficeId,
          'warnState': 0
        }
        queryWarningInfoLobCount(params).then((res) => {
          this.resetLobCount(res.data)
        })
      }
      if (this.activateTab !== this.preWarningLob) {
        this.$emit('getActiveNamePreWarning', this.activateTab.toUpperCase())
      }
    },
    resetLobCount(lobCounts) {
      const map = {
        se: '0',
        si: '0',
        ae: '0',
        ai: '0',
        re: '0',
        ri: '0',
        ie: '0'
      }
      if (lobCounts && lobCounts.length > 0) {
        const lobs = ['SE', 'SI', 'AE', 'AI', 'RE', 'RI', 'IE']
        for (const lobCount of lobCounts) {
          for (const lob of lobs) {
            if (lobCount.lob === lob) {
              map[lob.toLowerCase()] = lobCount.count
            }
          }
        }
      }
      this.lobCounts = map
    },
    handleTabClick(e) {
      this.$emit('getActiveNamePreWarning', this.activateTab.toUpperCase())
      if (this.$refs[e.name]) {
        this.keepState = {}
        this.$refs[e.name].clearGrid()
        if (e.name !== 'approvalMatters') {
          this.$refs[e.name].fetchData('init')
        } else {
          this.$refs[e.name].fetchData()
        }
      }
    },
    async refreshPage() {
      this.$refs[this.activateTab].clearGrid()
      await this.$refs[this.activateTab].fetchData('init')
    },
    showTab(jobType) {
      // 未配置时，显示全部，配置时，按照配置的显示
      if (!this.showJobTypes || this.showJobTypes.length === 0) {
        return true
      }
      return this.showJobTypes.findIndex(item => item === jobType) > -1
    }
  }
}
</script>

<style lang="scss">
.preWarning{
  position: relative;
  .actions {
    position: absolute;
    right: 0;
    top:3px;
    z-index: 99;
    span {
      font-size: 14px;
    }
    i:before{
      font-size: 16px;
    }
  }
  .tabSpanStyle{
    font-size: 14px
  }
}
</style>
